import React, { useCallback, useEffect, useMemo, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useDispatch, useSelector } from "react-redux";
import PageFilter from '../../../../../listing/components/filter/wishlist-filter.jsx'
// import Mask from "../../../../../../components/alert/mask";
import { FormattedMessage, useIntl } from "react-intl";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import Affix from "../../../../../../components/affix";
import { Swiper, SwiperSlide } from 'swiper/react'
import { BlackMask } from "../../../../../../components/mask";
import { IMAGE_GEEKO_LTD } from "../../../../../../../constants";

const FilterSelectedLine = props => {
	useStyles(cls)
	const {data, removeSelection} = props || {}

	return <React.Fragment>
		<div className={cls.SelectedCateGory}>
			<div className={cls.TagAll}>
			    <FormattedMessage id="all" defaultMessage={'All'} />{' >'}
			</div>
			<div className={cls.TagSelected}>
				{
					data?.length > 0 &&
					data.map((d, index) => {
						return <div className={cls.SelectedCateGoryItem}key={d+index} onClick={()=>removeSelection(d)}>
							{d.label}
							<span className={cls.Del}></span>
						</div>
					})
				}
			</div>
		</div>
	</React.Fragment>
}

const SorterPart = props => {
	useStyles(cls)
	const { filterMaskData, onClose, sorter, sorterChange } = props
	const { selections } = filterMaskData || {}
	const [values, setValues] = useState([])

	useEffect(() => {
		if(selections){
			if (selections instanceof Array) {
				setValues(selections)
			} else {
				const arr = []
				Object.keys(selections).map(key => {
					arr.push({ label: selections[key], value: key })
				})
				setValues(arr)
			}
		}
	}, [selections])

	return <React.Fragment>
		<div className={cls.PageSorter}>
			{
				values.map((v, index) => (
                    <div onClick={() => {
							sorterChange?.(v?.value, v)
							onClose()
						}}
                         className={`${cls.Sorter} ${sorter == v?.value ? cls.Selected : ''}`}
                         key={'sort'+index+v.value}>
                        {v.label}
                    </div>
                ))
			}
		</div>
	</React.Fragment>
}

const CategoryPart = props => {
	useStyles(cls)
	const { filterMaskData, onClose, category, categoryChange, wishListFilterCount, intl } = props
	const { selections, isMultiSelect } = filterMaskData || {}

	const removeSelection = (data) => {
		let list = [...(category || [])]
		let newList = list.filter(l => l?.value != data?.value)
		categoryChange(newList, filterMaskData)
	}

	const hasSelect = (selection) => {
		return category && category?.find(c => c?.value == selection?.value)
	}

	const selectionSelect = (value) => {
		if(isMultiSelect){
			let list = [...(category || [])]
			if(list?.find(c => c?.value == value?.value)){
                let newList = list?.filter(l1 => l1?.value != value?.value)
                categoryChange(newList, filterMaskData)
            } else {
				list.push(value)
				categoryChange(list, filterMaskData)
			}
		} else {
			categoryChange([value], filterMaskData)
		}
	}

    return (
        <div className={cls.SortList}>
			<div className={cls.SortListTitle}>{intl.formatMessage({id:'category', defaultMessage:'Category'})}</div>
            <div className={cls.CategoryBox}>
                {
                    category?.length > 0 &&
                    <FilterSelectedLine data={category} removeSelection={(value) => removeSelection(value)}/>
                }
                {
                    selections?.length > 0 &&
                    selections.map((selection,index) =>
						<div className={`${cls.FilterItem} ${hasSelect(selection) ? cls.Active : ''}`}
								onClick={evt => {
									selectionSelect(selection)
								}}
								key={'category'+index+selection.value}>
							{selection.label}
						</div>)
                }
            </div>

            <div className={`${cls.FilterButtons} ${cls.CategoryButtons}`}>
				<div className={cls.FilterNum}>
					<div>{wishListFilterCount}</div>
					<span><FormattedMessage id="products" defaultMessage={'Products'}/></span>
                </div>
				<div className={cls.FilterTools}>
					<div className={`${cls.Reset}`} onClick={() => {
						categoryChange(null, filterMaskData, 'clear')
					}}><FormattedMessage id="reset" defaultMessage={'Reset'}/></div>
					<div className={`${cls.Done}`} onClick={() => {
						categoryChange(category, filterMaskData, 'done');
						onClose(category)
					}}><FormattedMessage id="done" defaultMessage={'Done'}/></div>
				</div>
            </div>
        </div>
    )
}

const StatusPart = props => {
    useStyles(cls)
	const { filterMaskData, onClose, statusData, statusChangeFunc, wishListFilterCount, intl } = props
	const { selections, isMultiSelect } = filterMaskData || {}

	const removeSelection = (data) => {
		let list = [...(statusData || [])]
		let newList = list.filter(l => l?.value != data?.value)
		statusChangeFunc(newList, filterMaskData)
	}

	const hasSelect = (selection) => {
		return statusData && statusData?.find(c => c?.value == selection?.value)
	}

	const selectionSelect = (value) => {
		if(isMultiSelect){
			let list = [...(statusData || [])]
			if(list?.find(c => c?.value == value?.value)){
                let newList = list?.filter(l1 => l1?.value != value?.value)
                statusChangeFunc(newList, filterMaskData)
            } else {
				list.push(value)
				statusChangeFunc(list, filterMaskData)
			}
		} else {
			let list = [...(statusData || [])]
			if(list?.find(c => c?.value == value?.value)){
				statusChangeFunc([], filterMaskData)
			} else {
				statusChangeFunc([value], filterMaskData)
			}
		}
	}

    return (
        <div className={cls.SortList}>
			<div className={cls.SortListTitle}>{intl.formatMessage({id:'status', defaultMessage:'Status'})}</div>
            <div className={cls.CategoryBox}>
				{
                    statusData?.length > 0 &&
                    <FilterSelectedLine data={statusData} removeSelection={(value) => removeSelection(value)}/>
                }
                {
                    selections?.length > 0 &&
                    selections.map((selection, index) =>
						<div className={`${cls.FilterItem} ${hasSelect(selection) ? cls.Active : ''}`}
								onClick={evt => {
									selectionSelect(selection)
								}}
								key={'status'+index+selection.value}>
							{selection.label}
						</div>)
                }
            </div>

            <div className={`${cls.FilterButtons} ${cls.CategoryButtons}`}>
                <div className={cls.FilterNum}>
					<div>{wishListFilterCount}</div>
					<span><FormattedMessage id="products" defaultMessage={'Products'}/></span>
                </div>
				<div className={cls.FilterTools}>
					<div className={`${cls.Reset}`} onClick={() => {statusChangeFunc(null, filterMaskData, 'clear')}}><FormattedMessage id="reset" defaultMessage={'Reset'}/></div>
					<div className={`${cls.Done}`} onClick={() => {statusChangeFunc(statusData, filterMaskData, 'done'); onClose('', statusData);}}><FormattedMessage id="done" defaultMessage={'Done'}/></div>
				</div>
            </div>
        </div>
    )
}

const FilterItem = props => {
    useStyles(cls)
    const {data, showClickHandle, selectedName} = props
	const {fieldName, title} = data || {}

    return (
        <div>
            <span className={cls.FilterClickItem} onClick={() => {
                showClickHandle(data)
                if (window.GeekoSensors) {
                    window.GeekoSensors.Track("ELClick", {
                        clicks: fieldName
                    })
                }
            }
            }>
                <span className={`${selectedName == fieldName? cls.selected:''}`} style={{wordBreak:'break-all'}} >{title}</span>
                <Iconfont style={{ fontSize: 12 }}>&#xe671;</Iconfont>
            </span>
        </div>
    )
}

const FilterItemMask = props => {
    useStyles(cls)
    const { filterMaskData, onClose, category, statusData } = props
	const offset = ((44 + 32) * 2 / 75) + 'rem'

    return (
        <React.Fragment>
            {
                filterMaskData?.fieldName?.toLocaleLowerCase()?.indexOf('sort') != -1 ?
                <div style={{ position: 'relative', zIndex: 11 }}><SorterPart {...props}/></div>:
                filterMaskData?.fieldName?.toLocaleLowerCase()?.indexOf('category') != -1 ?
                <div style={{ position: 'relative', zIndex: 11 }}><CategoryPart {...props}/></div>:
                filterMaskData?.fieldName?.toLocaleLowerCase()?.indexOf('status') != -1 ?
                <div style={{ position: 'relative', zIndex: 11 }}><StatusPart {...props}/></div>:
                <React.Fragment></React.Fragment>
            }
            {filterMaskData && <BlackMask style={{bottom:0, top:'unset', height: `calc(100% - ${offset})`}} onClick={() => onClose(category, statusData)}/>}
        </React.Fragment>
    )
}

export const WishSortFilter = props => {

	useStyles(cls)
	const intl = useIntl()

	const {
		filterVo,
		statusData,
		statuses,
		statusChangeFunc,
		categories,
		sorters,
		category,
		filterSubmit,
		filterParams,
		resetFilterParams,
		categoryChange,
		updateFilterResultCount,
		showFilter,
		setShowFilter,
		filterMaskData,
		setFilterMaskData
	} = props

	

	useEffect(()=>{
		let body = document.getElementsByTagName('body')[0]
		if(filterMaskData){
			body.style.overflow = 'hidden'
		} else {
			body.style.overflow = 'auto'
		}
	}, [filterMaskData])

	const submitHandle = value => {
		filterSubmit(value)
		setShowFilter(false)

		if (window.GeekoSensors) {
			window.GeekoSensors.Track('Filter', {
				'filter': (value || []).map(item => {
					const fieldName = item.fieldName
					const selectionStr = (item.selections || []).map(s => s.value).join(',')
					return `${fieldName}:${selectionStr}`
				}).join(';'),
			})
		}
	}

	const clearHandle = () => {
		resetFilterParams()
		if (window.GeekoSensors) {
			window.GeekoSensors.Track("ELClick", {
				clicks: 'Clear'
			})
		}
	}

	const tagHandle = tag => {
		const isMuti = statuses?.isMultiSelect
		if (isActiveTag(tag)) {
			if(isMuti){
				let list = [...(statusData || [])]
				let newList = list.filter(l => l != tag.value)
				statusChangeFunc(newList, statuses, 'tag')
			} else {
				statusChangeFunc([], statuses, 'tag')
			}
		} else {
			if(isMuti){
				let list = [...(statusData || [])]
				list.push(tag)
				statusChangeFunc(list, statuses, 'tag')
			} else {
				statusChangeFunc([tag], statuses, 'tag')
			}
			if (window.GeekoSensors) {
				window.GeekoSensors.Track("Tag", {
					tag: tag?.value
				})
			}
		}
	}

	const isActiveTag = tag => {
		const statusParams = filterParams?.filter?.filterItems?.find(f => f?.fieldName == 'status') || null
		return !!(statusParams && statusParams?.selections?.find(s => s.value == tag?.value))
	}

	const filterClickHandle = () => {
		if (filterVo?.filter?.filterItems?.length > 0) {
			setShowFilter(true)
			setFilterMaskData(null)
		}
		if (window.GeekoSensors) {
			window.GeekoSensors.Track("ELClick", {
				clicks: 'filter'
			})
		}
	}

    const showClickHandle = useCallback((data) => {
		if(data?.fieldName == filterMaskData?.fieldName){
			setFilterMaskData(null)
		} else {
			setFilterMaskData(data)
			const fieldName = data?.fieldName
			const params = filterParams?.filter?.filterItems?.find(f => f?.fieldName == fieldName) || null
			if(fieldName?.indexOf('category') != -1){
				if(category && !looseEqual(params, category)){
					categoryChange(params?.selections, data)
				} else {
					updateFilterResultCount()
				}
			} else if(fieldName?.indexOf('status') != -1){
				if(statusData && !looseEqual(params, statusData)){
					statusChangeFunc(params?.selections, data)
				} else {
					updateFilterResultCount()
				}
			}
		}
    }, [filterMaskData, filterParams])

	//判断两个对象是否相同（包含绝对相等和他们是否有相同的形状）
	const looseEqual = (a, b) => {
		if (a === b) { //如果是绝对相等就直接返回true
			return true ;
		}
		//如果不是绝对相等就哦按的他们是否有相同的类型
		var isObjectA = isObject(a);
		var isObjectB = isObject(b);
		if (isObjectA && isObjectB) {//两个均是对象
		  try {
			var isArrayA = Array.isArray(a);
			var isArrayB = Array.isArray(b);
			if (isArrayA && isArrayB) {//如果都是数组
				if(a.length === b.length){//如果长度相等
					return a.every(function (e, i) {//用every和递归来比对a数组和b数组的每个元素，并返回
						 return looseEqual(e, b[i])
					})
				}
				//长度都不等直接返回false
				return  false;
			} else if (a instanceof Date && b instanceof Date) {//如果是Date 则直接getTime 比较
			    return a.getTime() === b.getTime()
			} else if (!isArrayA && !isArrayB) {//对象的比较
				//拿到两个对象的key
				var keysA = Object.keys(a);
				var keysB = Object.keys(b);
				if(keysA.length === keysB.length){//如果keys相等
						return keysA.every(function (key) {//用every和递归来比对a对象和b对象的每个元素值，并返回
							return looseEqual(a[key], b[key]);
						})
				}
				//长度都不等直接返回false
				return false;
			} else {
			  	return false
			}
		  } catch (e) {
			return false
		  }
		} else if (!isObjectA && !isObjectB) {//如果都不是对象则按String来处理
			return String(a) === String(b)
		} else {
			return false
		}
	}

	const isObject = (obj) => {
		return obj !== null && typeof obj === 'object'
	}

	const formateFilterParams = (params, type) => {
		let newParams = {...params}
		const endPrice = newParams?.filter?.endPrice || newParams?.filter?.endPrice === 0
		const startPrice = newParams?.filter?.startPrice || newParams?.filter?.startPrice === 0
		if(endPrice && startPrice && !type){
			let obj = {
				fieldName: 'price',
				endPrice: newParams?.filter?.endPrice,
				startPrice: newParams?.filter?.startPrice
			}
			if(newParams?.filter?.filterItems && Array.isArray(newParams?.filterItems)){
				newParams?.filter?.filterItems?.push(obj)
			} else {
				newParams.filter.filterItems = [obj]
			}
		}
		return type == 'all'? (newParams || {}): (newParams?.filter?.filterItems || [])
	}

	return <React.Fragment>

		<Affix offsetTop={44}>

			<div className={cls.SortFilter}>
				{
					sorters?.selections?.length > 0 &&
					<FilterItem selectedName={filterMaskData?.fieldName} data={{...sorters, fieldName: 'sorters', title: intl.formatMessage({id: 'sort',defaultMessage:'Sort'})}} showClickHandle={showClickHandle}/>
				}
				{
					categories?.isDisplay && categories?.selections?.length > 0 &&
					<FilterItem selectedName={filterMaskData?.fieldName} data={categories} showClickHandle={showClickHandle}/>
				}
				{
					statuses?.isDisplay && statuses?.selections?.length > 0 &&
					<FilterItem selectedName={filterMaskData?.fieldName} data={statuses} showClickHandle={showClickHandle}/>
				}

				<div className={cls.FilterClickBox} onClick={filterClickHandle}>
					<span className={cls.FilterClick}>
						<FormattedMessage id="filter" defaultMessage="Filter" />
						<img className={cls.FilterIcon} src={`${IMAGE_GEEKO_LTD}/chicme/20230608083651248263.png`} alt="" />
					</span>
				</div>
			</div>

			{
				filterMaskData &&
				<FilterItemMask
					filterMaskData={filterMaskData}
					onClose={(category, statusData) => {
						// maskCloseFunc()
						// maskCloseFunc(category, statusData)

						setFilterMaskData(null)
					}}
					intl={intl}
					{...props}
					/>
			}

		</Affix>


		{
			statuses?.selections?.length > 0 &&
			<div className={cls.TagContainer}>
				<Swiper
					onSlideChange={() => { }}
					onSwiper={(swiper) => { }}
					spaceBetween={10}
					slidesPerView={'auto'}
				>
					{
						statuses?.selections?.map((tag, index) =>
						<SwiperSlide className={`${cls.Tag} ${isActiveTag(tag) ? cls.Active : ''}`} key={'tag'+index+tag.value} onClick={() => { tagHandle(tag) }}>
							<span>{tag.label}</span>
						</SwiperSlide>)
					}
				</Swiper>
			</div>
		}

		<PageFilter
			value={formateFilterParams(filterParams)}
			handleClear={clearHandle}
			onSubmit={submitHandle}
			filterVo={formateFilterParams(filterVo, 'all')}
			showFilter={showFilter}
			onClose={() => {
				setShowFilter(false)
			}} />

	</React.Fragment>
}